module.exports = __webpack_public_path__ + "assets/font/SourceHanSans-Normal-fd67240a.woff2";